import { useSelector } from 'react-redux'
import { Element } from '../../../../../../common/html/element'
import { formatCurrencyFollowLocale } from '../../../../../../helpers/value'
import { CURRENCY } from '../../../../../../utils/currency'

export const PriceCell = ({ val = 0, rowId, getDataFromRedux }) => {
  const discountedPrice = useSelector(
    getDataFromRedux(rowId, 'discountedPriceVND'),
  )
  const locale = useSelector((state) => state.i18n.locale)

  return (
    <>
      {discountedPrice === val ? (
        <></>
      ) : (
        <Element
          style={{ color: '#9C9C9C', textDecorationLine: 'line-through' }}
        >
          {formatCurrencyFollowLocale(val, CURRENCY.VND, locale)}
        </Element>
      )}

      <Element style={{ color: '#0553A5', fontWeight: 600 }}>
        {formatCurrencyFollowLocale(discountedPrice, CURRENCY.VND, locale)}
      </Element>
    </>
  )
}
